import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class WorksCategoriesApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORKS_CATEGORIES, {
			entity: 'works_categories',
		})
	}
}
